import { render, staticRenderFns } from "./buyout.vue?vue&type=template&id=044a9183&scoped=true&"
import script from "./buyout.vue?vue&type=script&lang=js&"
export * from "./buyout.vue?vue&type=script&lang=js&"
import style0 from "./buyout.vue?vue&type=style&index=0&id=044a9183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a9183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044a9183')) {
      api.createRecord('044a9183', component.options)
    } else {
      api.reload('044a9183', component.options)
    }
    module.hot.accept("./buyout.vue?vue&type=template&id=044a9183&scoped=true&", function () {
      api.rerender('044a9183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/buyout.vue"
export default component.exports